export class KeyingAuthConfig {
  _clientId: string
  _domain: string
  _responseType: string
  _audience: string
  _redirectUrl: string
  _scope: string
  _logoutUrl: string

  constructor(
    clientId: string,
    domain: string,
    responseType: string,
    audience: string,
    redirectUrl: string,
    scope: string,
    logoutUrl: string
  ) {
    if (!clientId || !domain || !responseType || !audience || !redirectUrl || !scope || !logoutUrl) {
      throw new Error('Unable to create KeyingAuthConfig object')
    }
    this._clientId = clientId
    this._domain = domain
    this._responseType = responseType
    this._audience = audience
    this._redirectUrl = redirectUrl
    this._scope = scope
    this._logoutUrl = logoutUrl
  }

  public get clientId(): string {
    return this._clientId
  }
  public get domain(): string {
    return this._domain
  }
  public get responseType(): string {
    return this._responseType
  }
  public get audience(): string {
    return this._audience
  }
  public get redirectUrl(): string {
    return this._redirectUrl
  }
  public get scope(): string {
    return this._scope
  }
  public get logoutUrl(): string {
    return this._logoutUrl
  }
}
